// 该文件是整个项目的一些全局配置文件
module.exports = {
  /**
   * @description 页面的默认标签title
   * @type {string}
   */
  title: "好用、可协作的农场管理工具（农场ERP）",
  /**
   * @description 该项目的主体-功能暂未开发
   * @type {string} default
   */
  theme: "default",
};
